module.exports = __webpack_public_path__ + "assets/img/teacher (18).ceb6fee9.png";